import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TBrand, adaptBrandFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_BRAND } from '../../backend-paths';


export const brandDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ADMIN_BRAND}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_BRAND}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptBrandFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TBrand> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const brandDeleteSlice = createSlice({
	name: 'brandDeleteSlice',
	initialState,
	reducers: {
		clearBrandDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[brandDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[brandDeleteApi.fulfilled.type]: (state, action: PayloadAction<TBrand>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[brandDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useBrandDeleteSelector = () => useAppSelector(state => state[brandDeleteSlice.name]);

export const { clearBrandDelete } = brandDeleteSlice.actions;
